module.exports = __webpack_public_path__ + "static/media/hithsa2.7f43c2fb.png";